import { WarningOutlined } from "@ant-design/icons";
import { Modal, Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useMutation } from 'react-query';
import { message } from "antd";
import { CountInterface } from "./Interfaces";
import { deleteCount } from "../../api/inventoryCount";

type prop = {
    itemToDelete: {
        name: string,
        id: number
    };
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    title?: any;
    counts: CountInterface[],
    countsSearch: CountInterface[],
    setCounts: React.Dispatch<React.SetStateAction<CountInterface[]>>;
    setCountsSearch: React.Dispatch<React.SetStateAction<CountInterface[]>>;
}
const DeleteCount = ({ open, setOpen, title, counts, countsSearch, setCounts, itemToDelete, setCountsSearch }: prop) => {
    const [t] = useTranslation("common");

    const { mutateAsync: deleteCountMutation, isLoading } = useMutation(
        "deleteCount",
        ({ id }: { id: number }) =>
            deleteCount({ id }),
        {
            onSuccess: ({ data }) => {
                message.success(data.message)
                const removeItemCounts = counts.filter((item: CountInterface) => item.id != itemToDelete.id)
                const removeItemCountsSearch = countsSearch.filter((item: CountInterface) => item.id != itemToDelete.id)
                setCounts(removeItemCounts)
                setCountsSearch(removeItemCountsSearch)
                setOpen(false);
            },
            onError: ({ response }) => {

                message.error(response ? response.data.message : "Error: Couldn't delete record")
            }
        }
    );

    const handleclick = () => {
        deleteCountMutation({ id: itemToDelete.id });
    };

    return (
        <>
            <Modal
                closable={false}
                maskClosable={false}
                onCancel={() => setOpen(false)}
                open={open}
                centered
                title={
                    <>
                        <Row>
                            <Col span={3}>
                                <WarningOutlined
                                    style={{
                                        marginTop: "22px",
                                        color: "red",
                                        fontSize: "45px",
                                        marginRight: "12px",
                                    }}
                                />
                            </Col>
                            <Col span={19}>
                                <Col
                                    style={{
                                        fontSize: "32px",
                                        color: "#212121",
                                    }}
                                >
                                    {" "}
                                    {t("confirm-delete")}
                                </Col>
                                <Col
                                    span={19}
                                    style={{
                                        fontSize: "16px",
                                        color: "#212121",
                                        wordWrap: "break-word",
                                    }}
                                >
                                    {t("please-confirm-deleting")} {title}
                                </Col>
                                <Col
                                    span={24}
                                    style={{
                                        fontSize: "15px",
                                        color: "#212121",
                                    }}
                                >
                                    {itemToDelete.name}
                                </Col>
                            </Col>
                        </Row>
                    </>
                }
                onOk={handleclick}
                okText={`${t("confirm")}`}
                cancelText={`${t("cancel")}`}
                okButtonProps={{
                    style: {
                        height: "40px",
                        background: "#1677FF",
                        color: "#fff",
                        width: "100px",
                    },
                    loading: isLoading
                }}
                cancelButtonProps={{
                    style: {
                        color: "#1677FF",
                        border: "1px solid #1677FF",
                        height: "40px",
                        width: "100px",
                    },
                }}
            />
        </>
    );
};
export default DeleteCount;
